"use client";

import { useEffect } from "react";
import posthog from "posthog-js";

type MeResponse = { user: { id: string; firstName: string | null; lastName: string | null; email: string; role: string } | null };

/**
 * Identifie l'utilisateur côté PostHog une fois la session confirmée.
 *
 * - Le layout racine (Server Component) est rendu sur TOUTES les pages,
 *   y compris les pages publiques mises en cache CDN. Il ne doit donc JAMAIS
 *   lire la session lui-même (incident 2026-07-20 : userId/role embarqués
 *   dans le payload RSC de chaque page, potentiellement servis à un autre
 *   visiteur via le cache). Ce composant fetch /api/auth/header côté client
 *   après montage à la place.
 * - On n'envoie JAMAIS l'email dans les person properties (RGPD : l'email est
 *   un identifiant indirect, on garde le domaine si besoin de segmentation).
 */
export function PostHogIdentify() {
  useEffect(() => {
    if (typeof window === "undefined") return;
    let cancelled = false;

    fetch("/api/auth/header", { credentials: "include", cache: "no-store" })
      .then((r) => (r.ok ? r.json() : { user: null }))
      .then((d: MeResponse) => {
        if (cancelled || !posthog.__loaded) return;
        if (d.user?.id) {
          // distinct_id = userId stable (pas l'email — moins fuiteur en cas d'export).
          posthog.identify(d.user.id, {
            role: d.user.role ?? "patient",
            email_domain: d.user.email?.split("@")[1] ?? null,
          });
        }
      })
      .catch(() => {});

    return () => {
      cancelled = true;
    };
  }, []);

  return null;
}
